/**
 * MomentJS flight component
 */
define(function (require) {
        'use strict';

        var defineComponent = require('flightjs').component;
        var moment = require('moment');

        // Evil magic globals
        require('moment/locale/en-gb');
        require('moment/locale/en-au');
        require('moment/locale/en-ca');
        require('moment/locale/es');
        require('moment/locale/de');
        require('moment/locale/it');
        require('moment/locale/ja');
        require('moment/locale/pt');
        require('moment/locale/fr');

        return defineComponent(MomentWatcher);

        function MomentWatcher() {
            this.attributes({
                // new apps use time[datetime], Monolith uses .gmttime
                timeSelector: 'time[datetime], .gmttime',
                absoluteTimeSelector: 'time[datetime][data-absolute-time]',
                processedAttr: 'data-moment-processed',
                locale: false,
                cacheProcessedTimes: true
            });

            this.after('initialize', function() {
                moment.locale(this.attr.locale || this.$node.data('locale'));
                this.on(document, 'uiNeedsTimeUpdate', this.process);
                this.process();
            });

            this.process = function(e, data) {
                // absolute time
                this.selectChildren('absoluteTimeSelector').each(function(i, elm) {
                    $(elm)
                        .attr('title', this.getMomentString($(elm)))
                        .attr(this.attr.processedAttr, '')
                        .text(moment(this.nodeTime(elm)).format('ll'));
                }.bind(this));

                // relative time
                this.selectChildren('timeSelector').each(function(i, elm) {
                    $(elm)
                        .attr('title', moment(this.nodeTime($(elm))).format('LLL'))
                        .attr(this.attr.processedAttr, '')
                        .text(this.getMomentString($(elm)));
                }.bind(this));
            };

            this.selectChildren = function(selector) {
                var children = this.select(selector);

                if (this.attr.cacheProcessedTimes) {
                    children = children.not('[' + this.attr.processedAttr + ']');
                }

                return children;
            };

            this.getMomentString = function($node) {
                var suppressSuffix = $node.attr('data-no-suffix') !== undefined;
                return moment(this.nodeTime($node)).fromNow(suppressSuffix);
            };

            this.nodeTime = function(node) {
                var $node = $(node);
                return ($node.attr('datetime')) ? $node.attr('datetime') : $node.text();
            };
        }
    }
);



/** WEBPACK FOOTER **
 ** ./~/@99designs/brand-container/lib/ui/relative-time.js
 **/